import HttpStatus from 'http-status-codes';
import React from 'react';

export interface ErrorComponentProps {
  caughtError?: Error;
  status?: number;
  children?: React.ReactNode;
  onError?: () => JSX.Element | null;
  onReload?: () => void;
}

export const notAvailableError = (status?: number | null): boolean =>
  status ? [HttpStatus.UNAUTHORIZED, HttpStatus.FORBIDDEN, HttpStatus.NOT_FOUND].includes(status) : false;

export const shouldShowSignIn = (actorType?: string, statusCode?: number): boolean =>
  actorType === 'GuestUser' && notAvailableError(statusCode);
